var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.006,
    viewBox: "0 0 17 17.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attachment",
    transform: "translate(0 0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 17,
    height: 17,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attach-outline",
    d: "M162.842,84.135v6.1a1.7,1.7,0,1,0,3.4,0l.005-7.993a2.88,2.88,0,1,0-5.76,0v8.047a4.049,4.049,0,1,0,8.1,0v-7.52",
    transform: "translate(-155.891 -78.616)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileActive);
export default __webpack_public_path__ + "static/media/file_active.a6f39bbd5211e3f77eb0d2e77c336f39.svg";
export { ForwardRef as ReactComponent };